"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createYouTubeContentStyle;
function createYouTubeContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVZb3VUdWJlQ29udGVudFN0eWxlIiwiX3JlZiIsInZpZGVvSGVpZ2h0IiwiYm9yZGVyIiwiaGVpZ2h0Iiwid2lkdGgiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvWW91VHViZUNvbnRlbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlWW91VHViZUNvbnRlbnRTdHlsZSh7IHZpZGVvSGVpZ2h0IH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgIGJvcmRlcjogMCxcbiAgICBoZWlnaHQ6IHZpZGVvSGVpZ2h0LFxuICAgIHdpZHRoOiAnMTAwJSdcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRWUsU0FBU0EseUJBQXlCQSxDQUFBQyxJQUFBLEVBQXNDO0VBQUEsSUFBbkNDLFdBQVcsR0FBQUQsSUFBQSxDQUFYQyxXQUFXO0VBQzdELE9BQU87SUFDTEMsTUFBTSxFQUFFLENBQUM7SUFDVEMsTUFBTSxFQUFFRixXQUFXO0lBQ25CRyxLQUFLLEVBQUU7RUFDVCxDQUFDO0FBQ0gifQ==